import { useContext, useEffect } from "react";
import useFirestore from "../basic/useFirestore";
import { doc, getDoc } from "firebase/firestore";
import { FirebaseContext } from "../../providers/FirebaseProvider/FirebaseProvider";

// A missing document or a soft-deleted group (deletedAt set) is parsed as null,
// i.e. "not found", so the caller can redirect away — a deleted group must be
// unreachable, not even through its direct edit/planner URL.
export const parseGroupDoc = (snapshot) => {
  if (!snapshot.exists() || snapshot.data().deletedAt) {
    return null;
  }
  return {
    ...snapshot.data(),
    id: snapshot.id,
  };
};

function useUserGroupsByIdAndManager(groupId, managerId, preventCall) {
  const { firestoreDb } = useContext(FirebaseContext);

  const firestoreQueryMethod = async () =>
    getDoc(doc(firestoreDb, "groups", groupId));

  const { data, error, isLoading, refreshData } = useFirestore(
    firestoreQueryMethod,
    parseGroupDoc,
    preventCall,
  );

  useEffect(() => {
    if (groupId && managerId) {
      refreshData();
    }
  }, [groupId, managerId]);

  return {
    data,
    error,
    isLoading,
    refreshData,
  };
}

export default useUserGroupsByIdAndManager;
